import React from "react"
import Point from "../point/Point"
import Container from "../../../hoc/container/Container"
import style from "./Section.module.css"

const PrivacySection = props => {
  const pointsArray = []

  for (let point in props.points) {
    pointsArray.push({
      ...props.points[point],
    })
  }

  const points = pointsArray.map((point, index) => (
    <Point
      section={props.index}
      key={index}
      index={index + 1}
      heading={point.heading}
      body={point.body}
    />
  ))

  return (
    <section className={style.section} id={props.index}>
      <div className={style.headingWrapper}>
        <Container>
          <h2>
            {props.index}. {props.title}
          </h2>
        </Container>
      </div>

      <Container>{points}</Container>
    </section>
  )
}

export default PrivacySection
